/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_HeadwindInputs */

const en_ui_weather_headwind = /** @type {(inputs: Ui_Weather_HeadwindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Headwind`)
};

const de_ui_weather_headwind = /** @type {(inputs: Ui_Weather_HeadwindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegenwind`)
};

/**
* | output |
* | --- |
* | "Headwind" |
*
* @param {Ui_Weather_HeadwindInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_headwind = /** @type {((inputs?: Ui_Weather_HeadwindInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_HeadwindInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_headwind(inputs)
	return de_ui_weather_headwind(inputs)
});